import { render, staticRenderFns } from "./index.vue?vue&type=template&id=037c88c3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=037c88c3&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=037c88c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037c88c3",
  null
  
)

export default component.exports